export default {"src":"/_next/static/media/vinegar.921da1bb.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};